import React from 'react';

import { css } from '@emotion/css';

import { GrafanaTheme2 } from '@grafana/data';
import { t, Trans } from '@grafana/i18n';
import { Icon, Tooltip, useStyles2 } from '@grafana/ui';

import { LocalLogsDrilldownDefaultColumnsLogsDefaultColumnsRecord } from './types';
import { getNormalizedFieldName } from 'services/logFieldNames';

interface Props {
  isOpen: boolean;
  record: LocalLogsDrilldownDefaultColumnsLogsDefaultColumnsRecord;
}

export function RecordsCollapsibleLabel({ record, isOpen }: Props) {
  const styles = useStyles2(getStyles);
  return (
    <div className={styles.label}>
      <h5 className={styles.label__title}>
        <Trans i18nKey="components.app-config.default-columns.records-collapsible-label.display-fields">Display fields</Trans>
        <Tooltip
          content={t(
            'components.app-config.default-columns.records-collapsible-label.content-default-fields-display-visualizations-these-labels',
            'Default fields to display in logs visualizations for these labels'
          )}
        >
          <Icon className={styles.label__icon} name="info-circle" />
        </Tooltip>
      </h5>
      {!isOpen && (
        <span className={styles.label__pills}>
          {record.columns
            .filter((c) => c)
            .map((column) => (
              <span className={styles.label__pill} key={column}>
                {getNormalizedFieldName(column)}
              </span>
            ))}
        </span>
      )}
    </div>
  );
}

const getStyles = (theme: GrafanaTheme2) => ({
  label: css({
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    padding: theme.spacing(0.5, 0),
    minHeight: '32px',
  }),
  label__pills: css({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginLeft: theme.spacing(1),
  }),
  label__pill: css({
    border: `1px solid ${theme.colors.border.weak}`,
    borderRadius: theme.shape.radius.pill,
    padding: theme.spacing(0.25, 1.25, 0.25, 1.25),
    boxShadow: theme.shadows.z1,
  }),
  label__icon: css({
    marginLeft: theme.spacing(0.5),
  }),
  label__title: css({
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    flex: '1 0 auto',
  }),
});
